/**
 * Partner application notification outcome, as recorded by the backend on
 * each row: notifications = { applicant: {sent, at, error},
 * operator: {sent, to, failed, at, error} }.
 */
export const NOTIFY_CHANNELS = ['operator', 'applicant'];

export function notificationState(notifications) {
  const n = notifications || {};
  const recorded = NOTIFY_CHANNELS.some((c) => !!n[c]);
  const failed = NOTIFY_CHANNELS
    .filter((c) => n[c] && n[c].sent !== true)
    .map((c) => ({ channel: c, error: n[c].error || '', to: n[c].to || [] }));
  const operatorSent = !!(n.operator && n.operator.sent === true);
  return {
    recorded,
    failed,
    operatorSent,
    operatorTo: (n.operator && n.operator.to) || [],
    // Rows from before outcome tracking (or with a failed / missing
    // operator notice) can be re-sent from the panel.
    canResend: !recorded || failed.length > 0 || !operatorSent,
  };
}
